import React from 'react';
import { MediaItem } from '../../api/structs/media';
import { MediaOutputSpec } from '../../api/structs/media-spec';
import Modal from './Modal';
import RegenerateForm from './RegenerateForm';

interface RegenerateModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: MediaItem;
  outputSpec?: MediaOutputSpec;
  /** Stills from the same scene, offered as reference-frame bindings. */
  sceneImages?: MediaItem[];
  onSuccess: () => void;
}

/**
 * Single-item regeneration dialog. The actual form lives in `RegenerateForm`
 * so the scene-level `SceneRegenerateModal` can host the same form per tab;
 * this wrapper keeps the original one-item API for its remaining call site
 * (the editor's `SlideInspector`).
 */
const RegenerateModal: React.FC<RegenerateModalProps> = ({
  isOpen,
  onClose,
  item,
  outputSpec,
  sceneImages = [],
  onSuccess,
}) => (
  <Modal isOpen={isOpen} onClose={onClose} title="Regenerate Media">
    <RegenerateForm
      item={item}
      outputSpec={outputSpec}
      sceneImages={sceneImages}
      onSubmitted={() => {
        onSuccess();
        onClose();
      }}
      onCancel={onClose}
    />
  </Modal>
);

export default RegenerateModal;
